module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#gallery",
      toString: function () {
        return this.url;
      }
    }